import { useState } from 'react';
import styles from './ProfilePage.module.css';

import DefaultPhoto from '../../../assets/images/Photo.png';
import IconAndName from '../../../components/IconAndName/IconAndName';
import ResultAndCount from '../../../components/ResultAndCount/ResultAndCount';
import ExpandableCard from '../../../components/ExpandableCard/ExpandableCard';
import HeadingAndData from '../../../components/HeadingAndData/HeadingAndData';
import RadioComponent from '../../../components/RadioComponent/RadioComponent';
import HeadingAndDropDown from '../../../components/HeadingAndDropDown/HeadingAndDropDown';
import CalendarInput from '../../../components/CalendarInput/CalendarInput';
import IconAndHeading from '../../../components/IconAndHeading/IconAndHeading';
import SaveAndCancel from '../../../components/SaveAndCancel/SaveAndCancel';

import { AiOutlineMan, AiOutlineWoman } from 'react-icons/ai';
import { PiStudentBold } from 'react-icons/pi';

const ProfilePage = () => {
  const staffInfo = [
    { heading: 'Gender', data: 'Male' },
    { heading: 'Age', data: '32 Yrs' },
    { heading: 'Date of Birth', data: '27/08/2025' },
    { heading: 'Employee ID', data: 'EMP-8' },
  ];

  const [gender, setGender] = useState('Male');

  return (
    <div className={styles.Profile}>
      {/* Staff Info Top */}
      <section className={styles.studentProfileDetails}>
        <div className={styles.header}>
          <div className={styles.title}>Staff Profile</div>
          <IconAndName title="Send Invite" />
        </div>
        <div className={styles.mainContent}>
          <div className={styles.DetailsContainer}>
            <img
              src={DefaultPhoto}
              alt="Staff"
              className={styles.studentPhoto}
            />
            <div className={styles.StudentData}>
              <p className={styles.studentName}>Steve John</p>
              <div className={styles.studentInfo}>
                {staffInfo.map((item, index) => (
                  <div className={styles.infoItem} key={index}>
                    <p className={styles.infoTitle}>{item.heading}</p>
                    <p className={styles.infoData}>{item.data}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Summary Boxes */}
          <div className={styles.resultandcount}>
            <ResultAndCount
              label="Overall Attendance"
              count="90%"
              bgColor="rgba(from var(--Success_Color) r g b / 0.3)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Kiosk Code"
              count="7330"
              bgColor="rgba(from var(--Primary_Color) r g b / 0.2)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Room"
              count="3"
              bgColor="rgba(from var(--Error_Color) r g b / 0.3)"
              textColor="Black_Color"
            />
          </div>
        </div>
      </section>

      {/* Staff Details Form */}
      <ExpandableCard
        bodyColor="var(--White_Color)"
        headerColor="var(--Utility_Color1)"
        header={
          <IconAndHeading
            icon={<PiStudentBold color="var(--White_Color)" size={20} />}
            heading="Staff Details"
            headingColor="var(--Primary_Color)"
            iconBackgroundColor="rgba(from var(--Info_Color) r g b / 0.5)"
          />
        }
      >
        <div className={styles.three1frItemsFormRow}>
          <HeadingAndData
            label="Staff First Name"
            name="firstName"
            placeholder="John"
            required
          />
          <HeadingAndData
            label="Staff Last Name"
            name="lastName"
            placeholder="Jacob"
            required
          />
          <div className={styles.radioGroup}>
            <span className={styles.Label}>Gender *</span>
            <div className={styles.radioOptions}>
              <RadioComponent
                name="gender"
                value="Male"
                label="Male"
                checked={gender === 'Male'}
                onChange={(e) => setGender(e.target.value)}
              />
              <RadioComponent
                name="gender"
                value="Female"
                label="Female"
                checked={gender === 'Female'}
                onChange={(e) => setGender(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={styles.three1frItemsFormRow}>
          <HeadingAndDropDown
            label="Room"
            options={[{ label: '2A', value: '2A' }]}
            required
          />
          <HeadingAndDropDown
            label="Group"
            options={[{ label: 'Eee', value: 'Eee' }]}
          />
          <HeadingAndDropDown
            label="Program"
            options={[{ label: "Children's day", value: 'Children' }]}
            required
          />
        </div>

        <div className={styles.three1frItemsFormRow}>
          <CalendarInput
            label="Date Of Birth"
            fieldLabel="Date Of Birth"
            required
          />
          <HeadingAndDropDown
            label="Status"
            options={[{ label: 'Active', value: 'Active' }]}
            required
          />
          <CalendarInput
            label="Joining Date"
            fieldLabel="Joining Date"
            required
          />
        </div>

        <div className={styles.three1frItemsFormRow}>
          <CalendarInput
            label="Shift Start Time"
            fieldLabel="Shift Start Time"
            required
          />
          <CalendarInput
            label="Shift End Time"
            fieldLabel="Shift End Time"
            required
          />
        </div>

        <SaveAndCancel onSave={() => {}} onCancel={() => {}} />
      </ExpandableCard>
    </div>
  );
};

export default ProfilePage;
